import Index from './Index/index.js'
import Show from './Show'

export default {
  Index,
  Show,
}
